import { render } from "./App.vue?vue&type=template&id=148d9d56"
const script = {}

import "./App.vue?vue&type=style&index=0&id=148d9d56&lang=css"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__